import { apiRequest } from './apiHelpers';

const BASE_URL = '/api/e2e/admin/forms';

/**
 * Administration of E2E forms. Only the department ownership is exposed here —
 * form definitions themselves are created through import.
 * All endpoints require the inera-administrator role.
 */

export const fetchAdminForms = async () => {
  const data = await apiRequest(BASE_URL);
  return Array.isArray(data) ? data : [];
};

/** Pass an empty array to make the form visible to all departments. */
export const setFormDepartments = (formId, departmentIds) =>
  apiRequest(`${BASE_URL}/${encodeURIComponent(formId)}/departments`, {
    method: 'PUT',
    body: JSON.stringify({ departmentIds: departmentIds ?? [] }),
  });
